import Poppy from 'poppy';

import debounce from '../util/debounce';

const selectors = {
  tooltip: 'data-tooltip',
};

const classes = {
  tooltipDefault: 'poppy__tooltip',
};

let sections = {};

export default class Tooltip {
  constructor(el, options = {}) {
    this.tooltip = el;
    if (!this.tooltip.hasAttribute(selectors.tooltip)) return;
    this.label = this.tooltip.getAttribute(selectors.tooltip);
    this.pop = null;
    this.class = options.class || classes.tooltipDefault;
    this.transitionSpeed = options.transitionSpeed || 200;
    this.tooltipPosition = options.position || 'bottom';
    this.mouseEnterEvent = null;
    this.removePinEvent = () => this.removePin();
    this.init();
  }

  init() {
    this.pop = new Poppy({
      target: this.tooltip,
      popover: `
      <div class="${this.class}__wrapper">
      <div class="${this.class}">
      ${this.label}
      </div>
      </div>
      `,
      position: this.tooltipPosition,
      transitionSpeed: this.transitionSpeed,
    });

    this.mouseEnterEvent = debounce(this.pop.pin, 200);
    this.tooltip.addEventListener('mouseenter', this.mouseEnterEvent);
    this.tooltip.addEventListener('mouseleave', this.removePinEvent);
    document.addEventListener('poppy:close', this.removePinEvent);
    document.addEventListener('theme:scroll', this.removePinEvent);
  }

  removePin() {
    if (this.pop && this.pop.state.pinned) {
      this.pop.unpin();
    }
  }

  unload() {
    if (!this.pop) return;
    this.tooltip.removeEventListener('mouseenter', this.mouseEnterEvent);
    this.tooltip.removeEventListener('mouseleave', this.removePinEvent);
    document.removeEventListener('poppy:close', this.removePinEvent);
    document.removeEventListener('theme:scroll', this.removePinEvent);
  }
}

export const tooltipSection = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(`[${selectors.tooltip}]`);
    els.forEach((el) => {
      sections[this.id].push(new Tooltip(el));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};
